import React from 'react';
import PropTypes from 'prop-types';

const Stats = ({
  data,
  className = '',
  style = {}
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `row stats ${className}`,
    style: style
  }, data.map(item => {
    return /*#__PURE__*/React.createElement("div", {
      key: item.label,
      className: "stats__container col-xs-12"
    }, /*#__PURE__*/React.createElement("div", {
      className: "stats__label"
    }, item.label), /*#__PURE__*/React.createElement("div", {
      className: "stats__stat"
    }, item.symbol && item.symbol, " ", item.stat));
  }));
};

Stats.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    stat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    symbol: PropTypes.element
  })).isRequired,
  className: PropTypes.string,
  style: PropTypes.object
};
export default Stats;